module.exports = __webpack_public_path__ + "c45c6d7fc6bfb7b66ea0c75e8aa936fd.svg";